
//returns html for a tooltip
//title: the title of the tooltip
//points: an array of objects with 
//the format { name: String, color: String, value: String }
//each representing a point that the tooltip is illustrating
function getTooltipHTML (title, points) {
  let html = '<div class="m-1"><b class="text-muted">'
  html += title
  html += '</b><ul class="mb-0 mt-1 pl-4">'
  let limit = 10
  for(let x = 0; x < Math.min(limit, points.length); x++) {
    let point = points[x]
    html += '<li class="m-0" style="font-size: 120%; color:' + point.color + '"><b>' + point.name + ': <span class="text-light">' + point.value + '</span></b></li>'
    if(x === limit - 1) {
      html += '<b class="text-light">and ' + (points.length - limit) + ' more</b>'
    }
  }
  html += '</ul></div>'
  return html;
}

function getLabelStyle () {
  return {
    color: '#8796A3',
    fontSize: '10px',
    fontWeight: 600,
  }
}

function getYAxisStyle () {
  return {
    gridLineColor: '#F0F4F7',
    gridLineDashStyle: 'ShortDash',
    gridLineWidth: '2',
    labels: {
      style: getLabelStyle()
    }
  }
}

/**
 * returns options that (should) apply to most every graph
 * you'll need to merge it into custom graph options
**/
function getStyledGraphOptions () {
  return {
    credits: {
      enabled: false
    },
    yAxis: getYAxisStyle(),
    xAxis: {
      lineWidth: 0,
      tickLength: 0,
      labels: {
        style: getLabelStyle()
      }
    },
  }
}

export {
  getTooltipHTML,
  getYAxisStyle,
  getStyledGraphOptions
}




// WEBPACK FOOTER //
// ./src/reports/components/graphs/ReportGraphUtils.js